import { useState } from "react";

const Link = ({name}) => {


    return (
        <p>{name}</p>
    );
}
 
export default Link